import axios from "axios";
import { Component } from "react";
import { baseUrl, config } from './index.js';
import exportFromJSON from 'export-from-json';

export default class Master extends Component {

  static getPdf = async (title, list, type) => {
    const rows = [], category = [];
    list.map((item, index) => {
      if (item.category.length > 1) {
        item.category.map((cat, index) => {
          category.push(cat.name);
        });
      } else {
        category.push(item.category[0].name);
      }

      category.length > 0 ? rows.push({
        'Title': item.post_title, "Description": item.post_content, "Price": item.product_price,
        'Category': category
      }) : '';
    });

    const fileName = title + '(' + (type === 1 ? "All" : type === 3 ? "Publish" : "Pending") + ')';
    const exportType = 'xls';
    const data = Object.values(rows);
    exportFromJSON({ data, fileName, exportType });
  };

  static getStates = async () => {
    try {
      config.url = baseUrl + 'states?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getDistrict = async (data) => {
    try {
      config.url = baseUrl + 'districts?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAyushCountries = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/sites?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getCountries = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_country_data?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getCountryDetails = async (id) => {
    try {
      config.url = baseUrl + '/wp/v2/sites/' + id;
      config.method = 'get';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getDashboard = async () => {
    try {
      config.url = baseUrl + 'dashboard?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getTranslation = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_translation?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getLanguages = async () => {
    try {
      config.url = baseUrl + '/wp/v2/get_languages';
      config.method = 'get';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getCategories = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/event_category?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = '';
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

}
